export default {
    title: "Your approving manager is {email}"
}